export const formDataHeader = {
  'Content-Type': 'multipart/form-data',
};
